import React from 'react';
import UserForm from '../UserForm';
import { browserHistory } from 'react-router';
import User from '../../model/User';
import * as actions from '../../redux/actions';
import $ from 'jquery';

class UserCreatePage extends React.Component {
  state = {
    statusMessage: '',
  };

  handleSubmit(values) {
    // console.log('user create', values);
    const { dispatch } = this.props;
    return dispatch(actions.createUser(new User(values)))
      .then((user) => {
        //console.log('updated user', user);
        browserHistory.goBack();
      })
      .catch((e) => {
        this.setState({ statusMessage: e.message }, () => {
          let $statusMessage = $(this.refs.statusMessage);
          $statusMessage.removeClass('animated fadeIn');
          setTimeout(() => $statusMessage.addClass('animated fadeIn'), 200);
        });
      });
  }

  goBack() {
    browserHistory.goBack();
  }

  render() {
    let { statusMessage } = this.state;
    let { auth } = this.props;
    let loggedInUser = auth.user;
    let initialValues = new User();
    initialValues.lastUpdatedBy = loggedInUser.email;
    initialValues.isCreate = true;

    return (
      <div className='user-page'>
        <div className='title-row user-title'>
          <div className='title-back cursor-pointer' onClick={this.goBack.bind(this)}>
            <i className='fa fa-chevron-left' />
          </div>
          <div className='title' style={{ paddingLeft: '10px' }}>
            Create User
          </div>
        </div>

        {statusMessage && (
          <div className='error-message-bar' ref='statusMessage'>
            <i className='fa fa-warning' /> {statusMessage}
          </div>
        )}
        <UserForm initialValues={initialValues} onSubmit={this.handleSubmit.bind(this)} />
      </div>
    );
  }
}

export default UserCreatePage;



// WEBPACK FOOTER //
// ./src/components/pages/UserCreatePage.js